import chunk from 'lodash/chunk';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';
import { REHYDRATE } from 'redux-persist/lib/constants';
import qs from 'qs';

export default function products(
  state = {
    isRowsAdding: false,
    showLoadMore: false,
    isPageLoading: false,
    facets: [],
    products: [],
    rawProducts: [],
    gridRowCount: 10,
    hasErrored: false,
    totalResults: 0,
    currentPage: 1,
    query: {
      gridColumns: 3,
      viewType: 'outfitview'
    },
    sortBy: 'relevance',
    viewType: 'outfitview',
    apiLocation: {
      query: {}
    },
    displayAllFacetsCategories: false,
    closedFacetGroups: [],
    closedFacets: []
  },
  action
) {
  if (action.type === 'FETCHING_PRODUCTS') {
    return { ...state, ...action.values };
  }
  if (action.type === 'FETCHING_PRODUCTS_SUCCESS') {
    const { values = {} } = action;
    const { gridColumns = 3 } = values.query || {};

    const nextState = merge({}, state, values);
    if (state.isRowsAdding && values.products) {
      nextState.rawProducts = state.rawProducts.concat(values.products);
      nextState.products = state.products.concat(chunk(values.products, gridColumns));
    } else if (values.products) {
      nextState.rawProducts = values.products;
      nextState.products = chunk(values.products, gridColumns);
    }

    if (values.facets) {
      nextState.facets = formatFacets(values.facets);
    }

    nextState.gridRowCount = nextState.products.length;
    if (
      nextState.totalResults == 0 ||
      (nextState.gridRowCount && nextState.gridRowCount >= nextState.totalResults / gridColumns)
    ) {
      nextState.showLoadMore = false;
    } else {
      nextState.showLoadMore = true;
    }
    return nextState;
  }
  if (action.type === 'FETCHING_PRODUCTS_ERRORED') {
    const nextState = { ...state };
    if (
      state.totalResults == 0 ||
      (state.gridRowCount && state.gridRowCount >= state.totalResults)
    ) {
      nextState.showLoadMore = false;
    } else {
      nextState.showLoadMore = true;
    }
    return { ...nextState, ...action.values };
  }
  if (action.type === 'SET_VIEW_TYPE') {
    const query = { ...state.query, viewType: action.viewType };
    return { ...state, query };
  }
  if (action.type === REHYDRATE) {
    const { payload = {} } = action;
    const { products = {} } = payload;
    const { apiLocation = {} } = products;
    let apiLocationSearch = apiLocation.search || '';
    const { location = {} } = window;
    const { pathname = '', href = '' } = location;
    let search = href.split('?')[1] || '';
    if (apiLocationSearch.charAt(0) === '?') {
      apiLocationSearch = apiLocationSearch.slice(1);
    }
    let apiLocationSearchQ = {
      gridColumns: 3,
      viewType: 'outfitview',
      ...qs.parse(apiLocationSearch || '')
    };
    let searchQ = {
      query: ':relevance',
      gridColumns: '3',
      viewType: 'outfitview',
      ...qs.parse(search || '')
    };
    if (apiLocation.pathname === pathname && isEqual(apiLocationSearchQ, searchQ)) {
      return { ...products };
    }
    if (!pathname.startsWith('/c')) {
      return { ...products };
    }
    return { ...state };
  }
  if (action.type === 'SHOW_ALL_FACETS_CATEGORIES') {
    return { ...state, displayAllFacetsCategories: true };
  }
  if (action.type === 'HIDE_ALL_FACETS_CATEGORIES') {
    return { ...state, displayAllFacetsCategories: false };
  }
  if (action.type === 'SET_QUERY') {
    const { values = {} } = action;
    const nextState = merge({}, state, values);
    const { query = {} } = nextState;
    const { gridColumns = 3 } = query;

    nextState.products = chunk(state.rawProducts, gridColumns);
    nextState.gridRowCount = nextState.products.length;
    return nextState;
  }
  if (action.type === 'TOGGLE_FACET_GROUPS') {
    const { id } = action;
    const newState = { ...state };
    newState.closedFacetGroups = newState.closedFacetGroups || [];
    newState.closedFacetGroups = [...newState.closedFacetGroups];
    const index = newState.closedFacetGroups.indexOf(id);
    if (index > -1) {
      newState.closedFacetGroups.splice(index, 1);
    } else {
      newState.closedFacetGroups.push(id);
    }
    return newState;
  } else if (action.type === 'TOGGLE_FACET') {
    const { id } = action;
    const newState = { ...state };
    newState.closedFacets = newState.closedFacets || [];
    newState.closedFacets = [...newState.closedFacets];
    const index = newState.closedFacets.indexOf(id);
    if (index > -1) {
      newState.closedFacets.splice(index, 1);
    } else {
      newState.closedFacets.push(id);
    }
    return newState;
  }
  return state;
}

function formatFacets(facets = []) {
  return facets
    .filter(item => {
      return !['newcategory'].includes(item.code);
    })
    .map(facet => {
      const { name, code, values, maxPrice, minPrice, priceRangeValue = '' } = facet;
      let type = 'checkbox';
      let range = [];
      let labelPrefix = '';
      let labelSuffix = '';
      if (code === 'price' || code === 'exactdiscount') {
        type = 'range';
        range = priceRangeValue.split(',');
      }
      if (code === 'price') {
        labelPrefix = 'Rs. ';
      }
      if (code === 'exactdiscount') {
        labelSuffix = '%';
      }
      let items = values || [];
      return {
        name,
        code,
        type,
        minValue: minPrice,
        maxValue: maxPrice,
        range,
        labelPrefix,
        labelSuffix,
        items: items.map(item => {
          const { name, code, count, selected, query = {} } = item;
          let { url } = query;
          if (url) {
            let urlSplit = url.split('/c/');
            urlSplit.splice(0, 1);
            url = `${/c/}${urlSplit.join('')}`;
          }
          return {
            name,
            code,
            count,
            selected,
            url
          };
        })
      };
    });
}
